import {LoadingOutlined} from '@ant-design/icons'
import {ResponseBody as _ResponseBody} from '@/biz/ai'
import {ResponseBodyClarificationJson} from './ResponseBodyClarificationJson.jsx'
import {ResponseBodyImportConfirmJson} from './ResponseBodyImportConfirmJson.jsx'
import {ResponseBodyLoadingPlain} from './ResponseBodyLoadingPlain.jsx'
import {ResponseBodyOutOfScopeJson} from './ResponseBodyOutOfScopeJson.jsx'

const Bodies = {
    'clarification/json': ResponseBodyClarificationJson,
    'import-confirm/json': ResponseBodyImportConfirmJson,
    'loading/plain' : ResponseBodyLoadingPlain,
    'out-of-scope/json': ResponseBodyOutOfScopeJson,
}

export const ResponseBody = ({message, ...props}) => {
    const {content, type} = message

    if (! content) {
        return <LoadingOutlined />
    }

    const Body = Bodies[type] ?? _ResponseBody

    return (
        <Body
            message={message}
            {...props}
        />
    )
}
